<template>
	<div>
		<van-form>
			<van-field v-model="form.process_name" label="流程" readonly />
			<van-field v-model="form.xmmc" label="项目名称" readonly />
			<van-field v-model="form.cgnr" label="采购内容" readonly />
			<van-field v-model="form.je" label="采购金额" readonly />
		</van-form>
	</div>
</template>

<script>
export default {
	name: "purchase",
	props: {
		rform: Object
	},
	data() {
		return {
			form: {}
		};
	},
	watch: {
		rform: {
			immediate: true,
			handler(newV) {
				console.log(newV);
				this.form = newV;
			}
		}
	}
};
</script>